import { signal, effect, Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class SystemService {
  readonly isDarkMode = signal<boolean>(false)

  toggleDarkMode() {
    this.setDarkMode(!this.isDarkMode())
  }

  setDarkMode(value: boolean) {
    this.isDarkMode.set(value)
    document.documentElement.classList.toggle('fq-dark-mode', value)
  }

  constructor() {
    effect(() => {
      localStorage.setItem('darkMode', JSON.stringify(this.isDarkMode()))
    })
    const saved = localStorage.getItem('darkMode')
    if (saved !== null) {
      this.setDarkMode(JSON.parse(saved))
    }
  }
}
